var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExcedent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5762,
    cy: 13.5001,
    r: 9.23026,
    stroke: "#325A6D",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcedent);
export default __webpack_public_path__ + "static/media/iconExcedent.22b2bbf943a8477b9829e50e21c583c2.svg";
export { ForwardRef as ReactComponent };